import IdColumn from './IdColumn';
import NameColumn from './NameColumn';
import UrlColumn from './UrlColumn';
import SettingsColumn from './SettingsColumn';
import StatusColumn from './StatusColumn';
import TypeImageColumn from './TypeImageColumn';

// Column renderer factory
const createDataSourceColumnRenderers = () => ({
  'id': (props) => <IdColumn {...props} />,
  'type_image': (props) => <TypeImageColumn {...props} />,
  'name': (props) => <NameColumn {...props} />,
  'url': (props) => <UrlColumn {...props} />,
  'settings': (props) => <SettingsColumn {...props} />,
  'status': (props) => <StatusColumn {...props} />,
});

export {
  IdColumn,
  NameColumn,
  UrlColumn,
  SettingsColumn,
  StatusColumn,
  TypeImageColumn,
  createDataSourceColumnRenderers
};
